import React from 'react';

const Security = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-24 pb-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Security</h1>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Our commitment</h2>
              <p className="text-gray-700 leading-relaxed">
                Civioniks follows a security-first design aligned to ISO 27001 and SOC 2.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Controls</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Encryption (TLS in transit, AES-256 at rest).</li>
                <li>Regional hosting for GCC projects.</li>
                <li>Role-based access + MFA.</li>
                <li>Segregated environments for sensitive infrastructure data.</li>
                <li>Monitoring, logging, and audits.</li>
                <li>Incident response with GCC breach notification rules.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Customer responsibilities</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Manage account access, rotate API keys.</li>
                <li>Follow organizational security policies.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contact</h2>
              <p className="text-gray-700 leading-relaxed">
                Security inquiries: Hello@civioniks.com
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Security;
